import { OrderedMap } from 'immutable';
import BaseObject from './BaseObject';
import { ID } from '@app/types';

export interface WorkspaceAPIItem {
  id: number;
  name: string;
  avatar_url: string;
  is_admin: string;
}

export class WorkspaceMember extends BaseObject {
  isAdmin: boolean;
  avatarURL: string | null;
  email: string;
  firstName: string;
  lastName: string;

  constructor(props: any = {}) {
    super(props);

    this.isAdmin = props.isAdmin;
    if (props.hasOwnProperty('is_admin')) {
      this.isAdmin = props.is_admin;
    }

    this.avatarURL = props.avatar_url || props.avatarURL || null;
    this.email = props.email || '';
    this.firstName = props.first_name || props.firstName || '';
    this.lastName = props.last_name || props.lastName || '';
  }

  get displayName(): string {
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    } else if (this.email) {
      return this.email;
    } else {
      return '';
    }
  }
}

export default class Workspace extends BaseObject {
  isAdmin: boolean;
  name: string;
  avatarURL: string | null;
  members: OrderedMap<ID, WorkspaceMember>;

  constructor(props: any = {}) {
    super(props);

    this.isAdmin = props.isAdmin;
    if (props.hasOwnProperty('is_admin')) {
      this.isAdmin = props.is_admin;
    }

    this.name = props.name || '';
    this.avatarURL = props.avatar_url || props.avatarURL || null;
    this.members = props.members || OrderedMap();
  }
}
